module.exports = __webpack_public_path__ + "img/[奋斗].ad92d20f.svg";